import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const popupDepositsDetail = defineAsyncComponent(() => import('@/views/deposits/baDeposit/BADepositDetail.vue'));
const popupWithdrawDetail = defineAsyncComponent(() => import('@/views/deposits/baWithDraw/BAWithDrawDetail.vue'));

const popupImportDataFromKBNN = defineAsyncComponent(() =>
  import('@/views/deposits/baDeposit/fromKBNN/ImportDataFromKBNN.vue'),
);
const ComparingByMLNSPopup = defineAsyncComponent(() =>
  import('@/views/deposits/baDeposit/fromKBNN/ComparingByMLNSPopup.vue'),
);

const popupSelectDataFromKBNN = defineAsyncComponent(() =>
  import('@/views/deposits/baDeposit/fromKBNN/SelectDataKBNN.vue'),
);
const popupGenerateMultipleBaDepositFromKBNN = defineAsyncComponent(() =>
  import('@/views/deposits/baDeposit/fromKBNN/GenerateMultipleBaDepositFromKBNN.vue'),
);
const popupInternalTransferDetail = defineAsyncComponent(() =>
  import('@/views/deposits/baInternalTransfer/BAInternalTransferDetail.vue'),
);
const popupAdvanceNSNNDetail = defineAsyncComponent(() =>
  import('@/views/deposits/baAdvanceNSNN/BAAdvanceNSNNDetail.vue'),
);

export function registerDeposits(app) {
  const registerConfig = {
    BADepositDetail: popupDepositsDetail,
    BAWithDrawDetail: popupWithdrawDetail,
    BAInternalTransferDetail: popupInternalTransferDetail,
    BAAdvanceNSNNDetail: popupAdvanceNSNNDetail,
    ImportDataFromKBNN: popupImportDataFromKBNN,
    SelectDataKBNN: popupSelectDataFromKBNN,
    GenerateMultipleBaDepositFromKBNN: popupGenerateMultipleBaDepositFromKBNN,
    ComparingByMLNSPopup: ComparingByMLNSPopup,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'Deposits');
}
